import { ReactNode } from 'react'

import {
  FormControlLabel,
  Radio,
  RadioProps,
  SxProps,
  Theme,
  Typography,
} from '@mui/material'

import {
  labelSx as labelStyleSx,
  radioSx as radioStyleSx,
  wrapperSx as wrapperStyleSx,
} from './styles'

interface IRadioButtonProps extends RadioProps {
  label: string | ReactNode
  radioSx?: SxProps<Theme>
  labelSx?: SxProps<Theme>
  wrapperSx?: SxProps<Theme>
}

const RadioButton = ({
  label,
  value,
  radioSx,
  labelSx,
  wrapperSx,
  ...rest
}: IRadioButtonProps) => (
  <FormControlLabel
    control={
      <Radio {...rest} sx={{ ...radioStyleSx, ...radioSx } as SxProps<Theme>} />
    }
    value={value}
    label={
      typeof label === 'string' ? (
        <Typography sx={{ ...labelStyleSx, ...labelSx } as SxProps<Theme>}>
          {label}
        </Typography>
      ) : (
        label
      )
    }
    sx={{ ...wrapperStyleSx, ...wrapperSx } as SxProps<Theme>}
  />
)

export { RadioButton }
